/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:28 PM
 *
 */

import { MemberTest } from 'features/members/types';

export const getChartData = (testList: MemberTest[]) => {
  const chartData = testList.map((element) => {
    return Object.assign(
      {},
      {
        ...element.report.map((sub) => {
          return {
            [sub.slug]: {
              date: element.test_date,
              value: Number(sub.value),
            },
          };
        }),
      }
    );
  });
  const tempData = chartData ? chartData.map((element) => Object.values(element)) : [];
  const initialData: any = [];
  tempData.forEach((element) => initialData.push(...element));

  return initialData.reduce((acc: any, curr: any) => {
    const key = Object.keys(curr)[0];
    const accKeys = Object.keys(acc);
    const found = accKeys.filter((element) => element === key)[0];
    if (!found) {
      acc[key] = {
        values: [curr[key].value],
        dates: [curr[key].date],
      };
    } else {
      acc[key] = {
        values: [...acc[key].values, curr[key].value],
        dates: [...acc[key].dates, curr[key].date],
      };
    }

    return acc;
  }, {});
};
